module.exports = __webpack_public_path__ + "static/media/lvl-group-1.60be3ac8.png";